import React from 'react';
import { GroupBalancesTable } from 'components/table/group_balances/Table';

export const GroupBalance = () => {
    return (
        <>
        <GroupBalancesTable />
        </>
    );
}